export default __webpack_public_path__ + "static/media/earring.fc2385dc.svg";